import Component from 'flarum/common/Component';
import Button from 'flarum/common/components/Button';
import app from 'flarum/forum/app';

/*
 * Approve, or rewrite by hand — the two things a declared reviewer can do.
 *
 * Only rendered for languages the server put in `reviewable`, which it filters
 * by the actor's own `review_langs`. The client never decides who may vouch for
 * what; it would be re-implementing a rule that already has one home.
 */
export default class ReviewControls extends Component {
  oninit(vnode) {
    super.oninit(vnode);
    this.editing = null;
    this.draft = '';
    this.busy = false;
    this.rows = (this.attrs.post.attribute('reviewable') || []).slice();
  }

  view() {
    if (!this.rows.length) return null;

    return (
      <div className="SfReview">
        {this.rows.map((row) => (this.editing === row.lang ? this.editor(row) : this.row(row)))}
      </div>
    );
  }

  row(row) {
    return (
      <div className="SfReview-row">
        <span className="SfReview-lang">{row.lang.toUpperCase()}</span>
        <span className="SfReview-state">
          {row.approved
            ? app.translator.trans('scoreflection-translate.forum.review.approved', {
                origin: row.origin,
              })
            : app.translator.trans('scoreflection-translate.forum.review.pending')}
        </span>
        {!row.approved
          ? Button.component(
              {
                className: 'Button Button--link',
                loading: this.busy,
                onclick: () => this.approve(row),
              },
              app.translator.trans('scoreflection-translate.forum.review.approve')
            )
          : null}
        {Button.component(
          {
            className: 'Button Button--link',
            onclick: () => {
              this.editing = row.lang;
              this.draft = row.content;
            },
          },
          app.translator.trans('scoreflection-translate.forum.review.rewrite')
        )}
      </div>
    );
  }

  editor(row) {
    return (
      <div className="SfReview-editor">
        <textarea
          className="FormControl"
          rows="4"
          value={this.draft}
          oninput={(e) => (this.draft = e.target.value)}
        />
        <div className="SfReview-actions">
          {Button.component(
            {
              className: 'Button Button--primary',
              loading: this.busy,
              disabled: !this.draft.trim(),
              onclick: () => this.submit(row),
            },
            app.translator.trans('scoreflection-translate.forum.review.save')
          )}
          {Button.component(
            { className: 'Button Button--link', onclick: () => (this.editing = null) },
            app.translator.trans('core.forum.composer.discard_confirmation')
          )}
        </div>
      </div>
    );
  }

  approve(row) {
    this.busy = true;
    return app
      .request({
        method: 'POST',
        url: `${app.forum.attribute('apiUrl')}/post-translations/${row.id}/approve`,
      })
      .then(() => {
        row.approved = true;
      })
      .catch(() => {
        // 409 means the post changed underneath the translation, which is the
        // system working: the approval would have attested to text that is gone.
        app.alerts.show(
          { type: 'error' },
          app.translator.trans('scoreflection-translate.forum.review.failed')
        );
      })
      .then(() => {
        this.busy = false;
        m.redraw();
      });
  }

  submit(row) {
    this.busy = true;
    return app
      .request({
        method: 'POST',
        url: `${app.forum.attribute('apiUrl')}/posts/${this.attrs.post.id()}/translations`,
        body: { data: { lang: row.lang, content: this.draft } },
      })
      .then((result) => {
        const a = result.data.attributes;
        row.content = a.content;
        row.approved = a.approved;
        row.origin = a.origin;
        this.editing = null;
      })
      .catch(() => {
        app.alerts.show(
          { type: 'error' },
          app.translator.trans('scoreflection-translate.forum.review.failed')
        );
      })
      .then(() => {
        this.busy = false;
        m.redraw();
      });
  }
}
